import { PlusIcon } from '@heroicons/react/24/outline';

import { Restricted } from 'containers/Restricted';

import { PrimaryButton } from '@atoms/buttons/PrimaryButton';

import {
  BUSINESS_UNITS_CREATE_LABEL,
  BUSINESS_UNITS_EMPTY_CTA_TEST_ID,
  BUSINESS_UNITS_EMPTY_HEADING,
  BUSINESS_UNITS_EMPTY_TEST_ID
} from './constants';

import { EMPTY_STATE_MIN_HEIGHT } from '../constants';

type BusinessUnitsEmptyStateProps = {
  onCreate: () => void;
};

export const BusinessUnitsEmptyState = ({
  onCreate
}: BusinessUnitsEmptyStateProps) => (
  <div
    data-testid={BUSINESS_UNITS_EMPTY_TEST_ID}
    className={`flex ${EMPTY_STATE_MIN_HEIGHT} flex-1 flex-col items-center justify-center gap-6`}
  >
    <p className="text-lg font-medium leading-[22px] text-content-strong">
      {BUSINESS_UNITS_EMPTY_HEADING}
    </p>
    <Restricted requiredPermission="configurations:manage">
      <PrimaryButton
        data-testid={BUSINESS_UNITS_EMPTY_CTA_TEST_ID}
        icon={<PlusIcon className="size-4" />}
        onClick={onCreate}
      >
        {BUSINESS_UNITS_CREATE_LABEL}
      </PrimaryButton>
    </Restricted>
  </div>
);
